module.exports = __webpack_public_path__ + "img/gc_country_flag_bo.7a56a0f8.svg";